import { STATISTICS_PERMISSIONS } from 'constants/statisticsAccess';

import { routes } from 'data/routes';

/**
 * Maps route paths to the permissions required to access them.
 * A user needs at least ONE of the listed permissions (OR logic).
 * Routes not listed here are accessible to any authenticated user.
 *
 * Must stay in sync with:
 * - useNavData.ts (nav hiding)
 * - Backend @Roles / @AnyRole guards
 */
type RoutePermissionEntry = {
  path: string;
  permissions: string[];
  // Blocks access even if `permissions` matches — e.g. ADMIN is excluded
  // from Customer Mapper here because the admin panel is the intended tool
  // for that job, even on a dual-role (ADMIN + CUSTOMER_MAPPER) account.
  excludePermissions?: string[];
};

const ROUTE_PERMISSIONS: RoutePermissionEntry[] = [
  {
    path: routes.catalogue,
    permissions: ['CATALOGUE'],
  },
  {
    path: routes.orders,
    permissions: ['VIEW_ORDER', 'INSERT_ORDER'],
  },
  {
    path: routes.statistics,
    permissions: STATISTICS_PERMISSIONS,
  },
  {
    path: routes.budgets,
    permissions: ['INSERT_BUDGET'],
  },
  {
    path: routes.notifications,
    permissions: ['NOTIFICATIONS', 'CATALOGUE'],
  },
  // Customer Mapper feature disabled for now
  // {
  //   path: routes.customerMapper,
  //   permissions: ['CUSTOMER_MAPPER'],
  //   excludePermissions: ['ADMIN'],
  // },
  {
    path: routes.prices,
    permissions: ['DISTRIBUTOR'],
  },
];

export { ROUTE_PERMISSIONS };
export type { RoutePermissionEntry };
